import { commonFilter } from './filter';

export default {
  pageName: 'Custom AI Summary',
  pageId: '25050',
  pagePath: '/opinion/AIAnalysisHub/CustomAISummary',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    ...commonFilter,
    // 点击生成总结按钮
    GenerateAnalysis: {
      buttonId: '25050001',
    },
    // 点击例行报告按钮
    GenerateRepeat: {
      buttonId: '25050002',
    },
    // 预览页下载评论
    DownloadComments: {
      buttonId: '25050003',
    },
    // 预览页选中报告时间
    ChangeDate: {
      buttonId: '25050004',
    },
    // 预览页切换报告语种
    ChangeLanguage: {
      buttonId: '25050005',
    },
    // GPT重试
    RegenerateAnalysis: {
      buttonId: '25050006',
    },
    // 创建例行报告弹窗Confirm
    ConfirmGenerateAndRepeat: {
      buttonId: '25050007',
    },
    Stop: {
      buttonId: '25050008',
    },
  },
};
